import { useMemo } from 'react';
import { ColDef } from 'ag-grid-community';
import { useApi } from 'api/api-context';
import DataTable from 'components/tables/DataTable';
import ActionsColumn from 'components/tables/data/measuring-device/columns/ActionsColumn';
import DescriptionColumn from 'components/tables/data/measuring-device/columns/DescriptionColumn';
import ManufacturerColumn from 'components/tables/data/measuring-device/columns/ManufacturerColumn';
import MeasuringDeviceIdColumn from 'components/tables/data/measuring-device/columns/MeasuringDeviceIdColumn';
import MeasuringDeviceNameColumn from 'components/tables/data/measuring-device/columns/MeasuringDeviceNameColumn';
import SerialNumberColumn from 'components/tables/data/measuring-device/columns/SerialNumberColumn';
import TypeColumn from 'components/tables/data/measuring-device/columns/TypeColumn';
import { ADD_MEASURING_DEVICE_PAGE_PATH } from 'routes/paths';
import { getResponsiveActionsColumnWidth, useResponsiveDesign } from 'hooks/use-responsive-design';

/**
 * Table which displays measuring devices.
 */
export default function MeasuringDeviceTable() {
  const { getAction } = useApi();
  const { tableActionMode } = useResponsiveDesign();

  const columns = useMemo<ColDef[]>(
    () => [
      {
        field: 'measuringDeviceId',
        headerName: 'ID',
        sortable: true,
        unSortIcon: true,
        width: 76,
        minWidth: 76,
        maxWidth: 76,
        resizable: false,
        cellRenderer: MeasuringDeviceIdColumn,
      },
      {
        field: 'measuringDeviceName',
        headerName: 'Názov',
        minWidth: 200,
        sortable: true,
        unSortIcon: true,
        cellRenderer: MeasuringDeviceNameColumn,
      },
      {
        field: 'manufacturer',
        headerName: 'Výrobca',
        minWidth: 200,
        sortable: true,
        unSortIcon: true,
        cellRenderer: ManufacturerColumn,
      },
      {
        field: 'type',
        headerName: 'Typ',
        sortable: true,
        unSortIcon: true,
        minWidth: 200,
        cellRenderer: TypeColumn,
      },
      {
        field: 'serialNumber',
        headerName: 'Výrobné číslo',
        sortable: true,
        unSortIcon: true,
        minWidth: 200,
        cellRenderer: SerialNumberColumn,
      },
      {
        field: 'description',
        headerName: 'Info',
        unSortIcon: true,
        minWidth: 200,
        cellRenderer: DescriptionColumn,
      },
      {
        field: '_actions',
        headerName: '',
        pinned: 'right',
        width: getResponsiveActionsColumnWidth(194, tableActionMode),
        minWidth: getResponsiveActionsColumnWidth(194, tableActionMode),
        maxWidth: getResponsiveActionsColumnWidth(194, tableActionMode),
        cellRenderer: ActionsColumn,
      },
    ],
    [tableActionMode]
  );

  return (
    <DataTable
      tableId="measuring-devices"
      title="Meracie prístroje"
      hideToggleDiscarded
      addButtonText="Pridať nový"
      columns={columns}
      action={getAction('MeasuringDeviceList')}
      addButtonTarget={ADD_MEASURING_DEVICE_PAGE_PATH.original}
      dataExport={{
        modalTitle: 'Exportovať meracie prístroje',
        fileName: 'meracie-pristroje.xlsx',
        columnKeys: ['measuringDeviceId', 'measuringDeviceName', 'manufacturer', 'type', 'serialNumber', 'description'],
      }}
    />
  );
}
